module.exports = __webpack_public_path__ + "img/logo_400px.559f3d6c.png";